enum SortOptions {
  latest = "zonesPage.sort.latest",
  oldest = "zonesPage.sort.oldest",
}

interface Props {}

export type { Props };

export { SortOptions };
